import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProfissionalDetalharComponent } from './profissional-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ProfissionalDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class ProfissionalDetalharRoutingModule { }
